/* The Overview tab's blocks (journeys 3 and 5). Tokens only (ADR-0007). */

/* Four facts in a row; two at tablet width, one on a phone. `minmax(0, 1fr)` so a long note cannot
   push a tile past the viewport. */
/* **Fit, not four** (responsive pass, 2026-10-30). With a receipt open the drawer leaves these tiles
   about 570px, and four across was 130px each: the prior-period figure read "2,24…" — a number cut
   to an ellipsis that could be any of a hundred — and its label "PRIOR PERIO…". A tile is never
   narrower than 12.5rem, so it is two by two beside the drawer and four across when there is room. */
.facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 12.5rem), 1fr));
  gap: var(--gap);
  min-width: 0;
}

@media (width <= 1100px) {
  .facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (width <= 560px) {
  .facts {
    grid-template-columns: minmax(0, 1fr);
  }
}

.drill {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
}

.drill:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.drill:active {
  color: var(--ink);
}

.drill:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 3px;
  border-radius: 3px;
}

.empty {
  margin: 0;
  font-size: var(--t-dense);
  color: var(--muted);
}

/* One bar, segments in grade order. A segment's colour only orders the grades; the legend below
   names each in words and a number, so colour is never the only carrier. */
.bar {
  display: flex;
  height: 14px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--panel-3);
}

.segment {
  display: block;
  height: 100%;
  min-width: 2px;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.gradeButton {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 2px 6px 2px 2px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: none;
  font: inherit;
  font-size: var(--t-dense);
  color: var(--ink);
  cursor: pointer;
}

.gradeButton:hover {
  border-color: var(--accent-line);
  background: var(--panel-2);
}

.gradeButton:active {
  background: var(--panel-3);
}

.gradeButton:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.swatch {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 5px;
  font-size: var(--t-min);
  font-weight: 700;
  color: var(--on-fill);
}

.gradeName {
  font-weight: 600;
}

.gradeCount {
  color: var(--muted);
  font-size: var(--t-min);
}

.basisDisclosure {
  margin-top: 8px;
}

/* The delta is drawn for the dark hero card (ReadinessKpis) in near-white ink. These tiles are
   light, so the same markup is given ink measured against a light surface; the arrow, the
   magnitude and the words are unchanged. */
.facts [data-testid="kpi-delta"] {
  color: var(--ink-2);
}

.facts [data-testid="kpi-delta"] b {
  color: var(--ink);
}

.facts [data-testid="kpi-delta"] > span[aria-hidden="true"] > span {
  color: var(--muted);
}
